import { HeatingCoilIcon } from './HeatingCoilIcon';

/**
 * author: Michael Irigoyen
 * id FD4E8AC3-C868-429A-A7B9-5460AD347BC2
 * name heating-coil
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/heating-coil.svg
 * tags
 * - Home Automation 
 */
export const HeatedFloorIcon = HeatingCoilIcon;
export default HeatedFloorIcon